import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Edit,
	Create,
	Index
} from '@/router/index'

import Settings from '@/components/settings/Settings'

export const settings = [
	{
		path: '/settings/',
		name: 'settings',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settings',
					text: 'Impostazioni'
				}
			]
		},
		children: [
			{
				path: '/settings/',
				beforeEnter: ifAuthenticatedOnline,
				component: Settings
			}
		]
	}
]
